import { render, staticRenderFns } from "./Autorizaciones.vue?vue&type=template&id=1a2086ba&"
import script from "./Autorizaciones.vue?vue&type=script&lang=ts&"
export * from "./Autorizaciones.vue?vue&type=script&lang=ts&"
import style0 from "./Autorizaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports